import { Application } from "@hotwired/stimulus"
import { registerControllers } from "@stiege10/frontend-kit"

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus   = application

registerControllers(application)

export { application }
